<a (click)="onItemClicked()" (keyup.enter)="onItemClicked()" [attr.tabindex]="getTabIndex()" class="ap-list-item__container">
    <ng-content></ng-content>
    <ap-icon
        [name]="getActionIcon()"
        [size]="actionType() === 'externalLink' ? 'medium' : 'small'"
        class="ap-list-item__action"
        [class.ap-list-item--disabled]="disabled()"
        data-testid="list-item-link-icon"
    ></ap-icon>
</a>
